module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\nbackground: #f2f2f2;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}\r\n\r\n.box1{\r\n    padding:20px;\r\n    background: #fff;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/BoardMeet/boardmeeting/boardmeeting.component.css
// module id = ./src/app/landprocurement/BoardMeet/boardmeeting/boardmeeting.component.css
// module chunks = main